import React from 'react'
import AsyncTableListing from '../../ui-components/AsyncTableListing'
import BreadcrumbHeader from '../../layout/BreadcrumbsHeader'
import ThemeBGWrapper from '../../ui-components/ThemeBGWrapper'
import { useTheme } from '@emotion/react'
import { ReactComponent as RoundDetailsIcon } from "assets/rounds_icons/round_details_icon.svg"
import { Autocomplete, Box, Grid, IconButton, Menu, MenuItem, Stack, Tooltip, useMediaQuery } from '@mui/material'
import CustomTabs from '../../ui-components/CustomTabs'
import { TabContext } from '@mui/lab'
import { Add, CancelRounded, ConnectWithoutContact, Description, DoneAll, DoneRounded, EmailOutlined, FiberNew, FiberNewRounded, FilterAltOutlined, FilterAltRounded, LanguageOutlined, LinkedIn, Message, MessageOutlined, More, NewReleasesOutlined, Notes, OpenInNew, PublishedWithChanges, RateReview, RocketLaunch, Search, ThumbDown, ThumbUp, WhatsApp } from '@mui/icons-material'
import { makeStyles } from '@mui/styles'
import { amountInWords, checkForDomain, getFileIcon, hasPermission, navigateToDomain } from '../../utils'
import { Link, useNavigate } from 'react-router-dom'
import CustomInputField from 'ui-components/CustomInputField'
import { B400 } from 'ui-components/CustomButton';
import { Primary } from 'ui-components/Buttons';import { ReactComponent as MoreOptionsIcon } from "assets/rounds_icons/more_solid_icon.svg";
import NeedHelpButton from 'ui-components/NeedHelpButton'
import FilterPopup from "./popups/FilterPopup"
import ModalComponent from 'ui-components/ModalComponent'
import FeedbackPopup from './popups/FeedbackPopup'
import ShowInterestPopup from './popups/ShowInterestPopup'
import ShortlistConfirmationPopup from "ui-components/popups/DeleteConfirmationPopup"
import InvitedConfirmationPopup from "ui-components/popups/DeleteConfirmationPopup"
import InProgressConfirmationPopup from "ui-components/popups/DeleteConfirmationPopup"
import RejectedConfirmationPopup from "ui-components/popups/DeleteConfirmationPopup"
import RequestDocumentsPopup from "ui-components/popups/DeleteConfirmationPopup"
import Cookies from 'js-cookie'
import { FetchAllCategories, FetchAllStages, FetchAllSubCategories, FetchAllCurrencyLists } from 'api/utils'
import { UpdateStartupStatus } from 'api'
import InviteStartupPopup from './popups/InviteStartupPopup'
import { useSelector } from 'react-redux'
import { FetchAllStartupsListing, InviteStartupPOST, SaveFeedback, SaveInterest, SaveManageNotes, FetchInterestFeedbackStatus } from 'api'

import PDFView from './popups/PDFView'
import CustomToast from 'ui-components/CustomToast'
import AlertDialog from 'ui-components/popups/AlertPopup'
import toast from 'react-hot-toast'
import placeHolderImageNew from 'assets/no_data_images/Startups/new_startups.svg'
import placeHolderImageShortlisted from 'assets/no_data_images/Startups/shortlisted_startpus.svg'
import placeHolderImageRejected from 'assets/no_data_images/Startups/rejected_startus.svg'
import { useToast } from 'context/ToastContext'
import { ChangePipelineInvestorStatus } from 'api/startup_applications'

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        "&": {
            padding: "3rem"
        }
        // '& .MuiTabs-root > .MuiTabs-scroller > .MuiTabs-flexContainer' : {marginLeft: '2rem', gap: '5rem'}
    }
    //     '& .MuiTabs-root > .Mui-disabled.MuiTabs-scrollButtons': {
    //         display: 'none !important',
    //         transition: 'all 1s ease'
    //     },
    // }
}));

const StartupsListing = () => {
    const theme = useTheme();
    const { addToast } = useToast();
    const classes = useStyles();
    const navigate = useNavigate();
    const userDetails = useSelector((state) => state?.investorDetails?.data);
    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
    let [investor_id, setInvestorID] = React.useState(Cookies.get("X-ADMIN-ID") || null);
    // console.log(userDetails,"userDetails")
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const startupTabs = [
        { value: "invited", label: 'New', count: 10, read: false, icon: RocketLaunch },
        { value: "interested", label: 'Shortlisted', count: 10, read: false, icon: ThumbUp },
        { value: "in-progress", label: 'Selected', count: 10, read: false, icon: DoneAll },
        { value: "rejected", label: 'Rejected', count: 10, read: false, icon: ThumbDown },
    ]
    const [page, setPage] = React.useState(1);
    const [limit, setLimit] = React.useState(10);
    const parsedCookieForQueryParams = Cookies.get("startups_query") ? JSON.parse(Cookies.get("startups_query")) : {}
    const [queryParams, setQueryParams] = React.useState(parsedCookieForQueryParams);
    const [stage, setStage] = React.useState(null);
    const [category, setCategory] = React.useState(null);
    const [sector, setSector] = React.useState(null);
    const startups_tab_value = Cookies.get("startups_status") ? JSON.parse(Cookies.get("startups_status")) : "invited"
    const [value, setValue] = React.useState(startups_tab_value ?? "invited")
    const [search, setSearch] = React.useState("" || Cookies.get("search_startups"));
    const [reset, setReset] = React.useState(false);
    const [searchStatus, setSearchStatus] = React.useState(false);
    const [openFilter, setOpenFilter] = React.useState(false);
    // const { data: transformedData, isRefetching: isRefetchingStartupListing, isLoading: isLoadingStartupListing, refetch: refetchListing } = FetchAllStartupsListing({ page, limit, status: value, investor_id: investor_id, queryParams, searchText: search })
    const [transformedData, setTransformedData] = React.useState(null);
    const {
        mutateAsync: startupListingAsync,
        status: startupListingStatus,
        error: startupListingError,
        isLoading: isLoadingStartupListing,
        data: startupListingResponse,
    } = FetchAllStartupsListing();

    const { data: startup_stages, isRefetching: isRefetchingAllStages, isLoading: isLoadingAllStages, refetch: refetchAllStages } = FetchAllStages();
    const { data: startup_categories, isRefetching: isRefetchingAllCategories, isLoading: isLoadingAllCategories, refetch: refetchAllCategories } = FetchAllCategories();
    const { data: startup_sub_categories, isRefetching: isRefetchingAllSubcategories, isLoading: isLoadingAllSubcategories, refetch: refetchAllSubcategories } = FetchAllSubCategories({ category: queryParams?.category });

    const refetchListing = () => {
        // Get the _id for each based on the selected value
        const selectedStageId = queryParams?.stage
            ? startup_stages?.filter((item) => queryParams?.stage?.split(",")?.includes(item?.name))?.map(item => item?._id)
            : null;
        const selectedCategoryId = queryParams?.category
            ? startup_categories?.filter((item) => queryParams?.category?.split(",")?.includes(item?.name))?.map(item => item?._id)
            : null;
        const selectedSectorId = queryParams?.sector
            ? startup_sub_categories?.filter((item) => queryParams?.sector?.split(",")?.includes(item?.sub_category))?.map(item => item?._id)
            : null;
        // console.log(selectedSectorId, "sector")
        // console.log(selectedCategoryId, "sector")
        // console.log(selectedStageId, "sector")

        // Construct the payload
        const payloadQueryParams = {
            ...(selectedStageId && { "select_stages": selectedStageId }),
            ...(selectedCategoryId && { "category": selectedCategoryId }),
            ...(selectedSectorId && { "sub_sector": selectedSectorId }),
        };

        // Call the API with the constructed payload
        startupListingAsync({
            payload: {
                status: value ? value : "invited",
                page: page ? page : 1,
                limit: limit ? limit : 20,
                // sort: sort ? sort : -1,
                name: search ? search : "",
            },
            investor_id,
            queryParams: {
                ...payloadQueryParams,
            }
        }, {
            onSuccess: (response) => {
                // console.log(response?.data, "response")
                setTransformedData({
                    data: response?.data?.data || [],
                    count: response?.data?.totalCount || 0,
                });
            },
            onError: (error) => {
                setTransformedData({
                    data: [],
                    count: 0,
                })
                // console.log(error, "error")
            }
        })
    }

    React.useEffect(() => {
        refetchListing();
    }, [value, page, limit, queryParams])

    React.useEffect(() => {
        if (searchStatus) {
            refetchListing();
        }
    }, [searchStatus])

    const [isMobile, setIsMobile] = React.useState(false);
    React.useEffect(() => {
        if (typeof window !== "undefined") {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isMobileDevice =
                /Android|iPhone|iPad|iPod/i.test(userAgent) && window.innerWidth < 768; // Extra check for screen width
            setIsMobile(isMobileDevice);
        }
    }, []);


    const {
        mutateAsync: FetchStatusAsync,
        status: fetchStatusStatus,
        error: fetchStatusError,
        isLoading: isUpdatingFetchStatus,
        data: fetchStatusResponse,
    } = FetchInterestFeedbackStatus();

    const { data: currencyList, isLoading: isLoadingCurrency } =
        FetchAllCurrencyLists();


    const [isEnabledInterest, setIsEnabledInterest] = React.useState(false);
    const [isEnabledFeedback, setIsEnabledFeedback] = React.useState(false);
    const [showAlert, setShowAlert] = React.useState(false)
    const [alertMessage, setAlertMessage] = React.useState(null)
    const [alertHeading, setAlertHeading] = React.useState(null)

    // React.useEffect(() => {
    //     if (fetchStatusResponse && fetchStatusResponse?.data?.statusCode == 200) {
    //         setIsEnabledInterest(fetchStatusResponse?.data?.investorInfo == null)
    //         setIsEnabledFeedback(fetchStatusResponse?.data?.feedback == null)
    //     } else {
    //         // fetchStatusResponse?.data?.message && toast.error(<CustomToast message={fetchStatusResponse?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} />, {
    //         //     duration: 4000,
    //         //     position: "top-right",
    //         //     style: {
    //         //         padding: "15px 30px",
    //         //     },
    //         // });
    //     }
    // }, [fetchStatusResponse?.data?.statusCode]);

    // console.log(transformedData?.data, "startupListingData")

    React.useEffect(() => {
        let count = 0;
        if (!isLoadingStartupListing && count == 0) {
            if (transformedData?.count && transformedData?.count == 0 && value === "invited") {
                if (search?.trim()?.length === 0 && Object.keys(queryParams)?.length === 0)
                    handleInviteStartupPopupOpen()
                count = 1;
            }
        }
    }, [isLoadingStartupListing, value, transformedData])

    // Memoized Tooltip Icon Component
    const MemoizedTooltipIcon = React.memo(({ title, icon, onClick }) => (
        <Tooltip title={title}>
            <IconButton onClick={onClick}>{icon}</IconButton>
        </Tooltip>
    ));

    const handleTabChange = (event, newValue) => {
        // console.log("value", newValue)
        setValue(newValue);
        Cookies.set("startups_status", JSON.stringify(newValue), { expires: 1 });
        setPage(1);
        setTransformedData({
            ...transformedData,
            count: 0
        })
    };


    const [openInvitedConfirmationPopup, setOpenInvitedConfirmationPopup] = React.useState(false);

    const handleInvitedConfirmationPopupClose = () => {
        setOpenInvitedConfirmationPopup(false);
        setCurrentRow(null);
    }

    const handleInvitedConfirmationPopupOpen = ({ row }) => {
        setOpenInvitedConfirmationPopup(true);
        setCurrentRow(row?.original);
    }

    const handleSubmissionInvited = ({ row }) => {
        // setCurrentRow(row);
        // console.log(row);
        // updateStartupStatusAsync({
        //     "startup_id": "66f285de9ce0f2c5615f20e5",
        //     "status_code": "Inviteded"
        // }).then((response) => {
        //     refetchListing();
        //     handleInvitedConfirmationPopupClose();
        // }).catch((error) => {

        // })

        updateStartupStatusAsync({
            payload: {
                "status": "invited"
            }
            , pipeline_id: currentRow?.pipeline_id
        }).then((response) => {
            addToast("Moved to Invited", "success")
            refetchListing();
            handleInvitedConfirmationPopupClose();
        }).catch((error) => {

        })
    }

    const RowActions = ({ row, iconsColor = theme.palette.customColors.indigo700, index }) => {
        // return <>

        // </>
        // console.log(row, "row")

        const [anchorEl, setAnchorEl] = React.useState(null);
        const openMenu = Boolean(anchorEl);
        const handleClickMenu = (event, index) => {
            setAnchorEl(event.currentTarget);
            // setCurrentIndex(index)
            // console.log(event.currentTarget,"re")
        };
        const handleCloseMenu = (event) => {
            // console.log(event,"event")
            setAnchorEl(null);
            // setCurrentIndex(null);
        };

        const [anchorConnectEl, setAnchorConnectEl] = React.useState(null);
        const openConnectMenu = Boolean(anchorConnectEl);
        const handleClickConnectMenu = (event, index) => {
            setAnchorConnectEl(event.currentTarget);
            // setCurrentIndex(index)
            // console.log(event.currentTarget,"re")
        };
        const handleCloseConnectMenu = (event) => {
            // console.log(event,"event")
            setAnchorConnectEl(null);
            // setCurrentIndex(null);
        };

        const phone_number = row?.original?.phone_code + row?.original?.mobile_number

        // switch (value) {
        //     case "new": return <>
        return <>
            <MemoizedTooltipIcon title="Send Message" onClick={(e) => handleClickConnectMenu(e)} icon={
                // <MessageOutlined
                <MessageOutlined sx={{
                    color: theme.palette.customColors.indigo600
                }}
                />
            }
            // <ConnectWithoutContact sx={{
            //     color: theme.palette.customColors.indigo600
            // }} />} 
            />
            <Menu
                anchorEl={anchorConnectEl}
                id="connect-menu"
                open={openConnectMenu}
                aria-controls={openConnectMenu ? 'fade-menu' : 'fade-menu'}
                aria-haspopup="true"
                aria-expanded={openConnectMenu ? 'true' : 'false'}
                onClose={handleCloseConnectMenu}
                onClick={handleCloseConnectMenu}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        padding: "12px",
                        borderRadius: "8px",
                        "& > ul.MuiList-root": { padding: "0 !important" },
                        bgcolor: theme.palette.customColors.g400,
                        color: theme.palette.customColors.whiteBG,
                        // '&::before': {
                        //     content: '""',
                        //     display: 'block',
                        //     position: 'absolute',
                        //     top: 1,
                        //     right: 5,
                        //     width: 10,
                        //     height: 10,
                        //     bgcolor: theme.palette.customColors.g900,
                        //     transform: 'translateY(-50%) rotate(45deg)',
                        //     zIndex: 0,
                        // },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
            >
                {/* {value === "invited" && <> */}
                <MenuItem
                    disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                        // if (row?.original?._id) {
                        //     Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
                        // }
                        // if (row?.original?.email) {

                        // }
                    }}>
                    <a href={`mailto:${row?.original?.email}`} rel="noopener noreferrer" style={{ textDecoration: 'none', color: "inherit", display: "flex", alignItems: 'center' }} >
                        <EmailOutlined sx={{ mr: 1 }} /> Email
                    </a>
                </MenuItem>
                <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                    // if (row?.original?._id) {
                    //     Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
                    // }
                }}>
                    <a href={isMobile ? `https://wa.me/${phone_number}` : `https://web.whatsapp.com/send?phone=${phone_number}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: "inherit", display: "flex", alignItems: 'center' }} >
                        <WhatsApp sx={{ mr: 1 }} /> WhatsApp
                    </a>
                </MenuItem>

                {/* </> */}
                {/* } */}
                {/* {value == "rejected" && <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShortlistConfirmationPopupOpen({ row })}>
                  
                    Move to Shortlisted
                </MenuItem>} */}
            </Menu>
            {row?.original?.slug && row?.original?.slug != null &&
                (String(row?.original?.slug)?.length > 0) &&
                <Tooltip title="View Profile">
                    <IconButton centerRipple={false} sx={{ borderRadius: "4px", color: theme.palette.customColors.indigo600 }} onClick={() => {
                        window.open(navigateToDomain("main", ("startup/" + row?.original?.slug)))
                    }}>
                        <OpenInNew fontSize='1.5rem' />
                    </IconButton>
                </Tooltip>
            }
            <IconButton
                sx={{ borderRadius: "4px" }}
                id={`more-details-button-${index}`}
                size="small"
                aria-controls={openMenu ? 'more-details-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}
                onClick={(e) => handleClickMenu(e)}
                centerRipple={false}
            >
                <MoreOptionsIcon />
            </IconButton>
            {/* TO be reverted After Demo */}
            {/* {value !== "rejected" &&  */}
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                aria-controls={openMenu ? 'fade-menu' : 'fade-menu'}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : 'false'}
                onClose={handleCloseMenu}
                onClick={handleCloseMenu}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        padding: "12px",
                        borderRadius: "8px",
                        "& > ul.MuiList-root": { padding: "0 !important" },
                        bgcolor: theme.palette.customColors.g400,
                        color: theme.palette.customColors.whiteBG,
                        // '&::before': {
                        //     content: '""',
                        //     display: 'block',
                        //     position: 'absolute',
                        //     top: 1,
                        //     right: 5,
                        //     width: 10,
                        //     height: 10,
                        //     bgcolor: theme.palette.customColors.g900,
                        //     transform: 'translateY(-50%) rotate(45deg)',
                        //     zIndex: 0,
                        // },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
            >
                {/* {value !== "rejected" && <>
                    {value !== "interested" && hasPermission("startups", "submit_interest", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShowInterestPopupOpen({ row })}>

                        Submit Interest
                    </MenuItem>}
                    {value === "in-progress" && hasPermission("startups", "manage", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShortlistConfirmationPopupOpen({ row })}>

                        Move to Shortlisted
                    </MenuItem>}
                    {value === "interested" && hasPermission("startups", "manage", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleInProgressConfirmationPopupOpen({ row })}>

                        Move to Selected
                    </MenuItem>}
                    {hasPermission("startups", "manage", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleRejectConfirmationPopupOpen({ row })}>

                        Move to Rejected
                    </MenuItem>}
                    {hasPermission("startups", "submit_feedback", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleFeedbackPopupOpen({ row })}>

                        Submit Feedback
                    </MenuItem>}
                    <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                        if (row?.original?._id) {
                            Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
                        }
                    }}>
                        View Details
                    </MenuItem>
                </>} */}

                {/* TO Be Reverted After Demo */}
                {/* {value !== "rejected" && <> */}
                {/* {value !== "interested" && hasPermission("startups", "submit_interest", userPermissions) &&  */}

                {/* } */}
                {/* {value === "in-progress" && hasPermission("startups", "manage", userPermissions) && */}
                {value !== "invited" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleInvitedConfirmationPopupOpen({ row })}>

                    Move to New
                </MenuItem>}

                {value !== "interested" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShortlistConfirmationPopupOpen({ row })}>

                    Move to Shortlisted
                </MenuItem>}
                {/* } */}
                {/* {value === "interested" && hasPermission("startups", "manage", userPermissions) &&  */}
                {value !== "in-progress" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleInProgressConfirmationPopupOpen({ row })}>

                    Move to Selected
                </MenuItem>}
                {/* } */}
                {/* {hasPermission("startups", "manage", userPermissions) &&  */}
                {value !== "rejected" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleRejectConfirmationPopupOpen({ row })}>

                    Move to Rejected
                </MenuItem>}
                {/* } */}
                {/* {hasPermission("startups", "submit_feedback", userPermissions) &&  */}
                <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShowInterestPopupOpen({ row })}>

                    Submit Interest
                </MenuItem>
                <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleFeedbackPopupOpen({ row })}>

                    Submit Feedback
                </MenuItem>
                {/* } */}
                <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                    if (row?.original?._id) {
                        Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
                    }
                }}>
                    View Details
                </MenuItem>
                {/* </>} */}
            </Menu>
            {/* } */}
        </>
    }

    const NewColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
        // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
        { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
        { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
        { Header: 'Round Size', accessor: 'totalRoundSize', minWidth: 150, align: 'center' },
        { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
        { Header: 'Date', accessor: 'invited_date', minWidth: 100, align: 'center' },
        // { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center', tooltip: 'interested_amount' },
        { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
        { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
        // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'right' }
    ];

    const ShortlistedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
        // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
        { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
        { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
        { Header: 'Round Size', accessor: 'totalRoundSize', minWidth: 150, align: 'center' },
        { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
        { Header: 'Date', accessor: 'interested_shown_date', minWidth: 100, align: 'center' },
        // { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center' },
        { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center', tooltip: 'interested_amount' },
        { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
        { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
        // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'right' }
    ]

    const InProgressColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
        // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
        { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
        { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
        { Header: 'Round Size', accessor: 'totalRoundSize', minWidth: 150, align: 'center' },
        { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
        { Header: 'Date', accessor: 'in_progress_date', minWidth: 100, align: 'center' },
        // { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center' },
        { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center', tooltip: 'interested_amount' },
        { Header: 'Allocated Amount', accessor: 'formatted_allocated_amount', minWidth: 150, align: 'center', tooltip: 'allocated_amount' },
        { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
        { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
        // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'right' }
    ]

    const RejectedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
        // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
        { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
        { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
        { Header: 'Round Size', accessor: 'totalRoundSize', minWidth: 150, align: 'center' },
        { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
        { Header: 'Date', accessor: 'investor_rejected_date', minWidth: 100, align: 'center' },
        { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
        { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
        // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'right' }
    ]

    // const columns = () => {
    //     switch (value) {
    //         case "new": return NewColumns;
    //         case "shortlisted": return ShortlistedColumns;
    //         case "rejected": return NewColumns;
    //         default: return NewColumns;
    //     }
    // }

    const columns = value === "invited" ? NewColumns : value === "interested" ? ShortlistedColumns : value === "rejected" ? RejectedColumns : value === "in-progress" ? InProgressColumns : NewColumns;

    // Memoized Data Transformation
    const useFormattedData = (transformedData) => {
        return React.useMemo(() => {
            return transformedData?.data && transformedData?.data?.length > 0
                ? transformedData?.data?.map((item) => {
                    // console.log(item)
                    const pipeline_details = item?.currency_id ? {
                        interested_amount: item?.interested_amount ?? null,
                        _interested_amount:
                            <Tooltip title={amountInWords(item?.interested_amount, currencyList?.find(item => item?._id === item?.currency_id)?.code)}>
                                {item?.formatted_interested_amount}</Tooltip>,
                        formatted_interested_amount: item?.formatted_interested_amount,
                    } : {}
                    // console.log(pipeline_details, "pipeline_details")
                    return ({
                        ...item,
                        ...pipeline_details,
                        name: item?.startup_name,
                        // formatted_interested_amount: "",
                        location: item?.city_id && item?.country_id ? `${item?.city_id?.name}, ${item?.country_id?.name}` : "-",
                        currency: item?.currency_info
                            ? item?.currency_info?.code
                            : null,
                        category_sub_sector: item?.category_id && item?.category_id?.length > 0
                            ? `${item?.category_id?.map(item => item?.name)} ${item?.sector_id && item?.sector_id?.length > 0 ? "(" + item?.sector_id?.map(item => item?.name) + ")" : "-"}`
                            : "-",
                        stage: item?.stage_id && item?.stage_id?.length > 0 ? `${item?.stage_id?.map(item => item?.name)}` : "-",
                        image: item?.startup_logo_path,
                        pitch_deck: item?.pitchDeckFileUrl && !item?.pitchDeckFileUrl?.includes("undefined") && !item?.pitchDeckFileUrl?.includes("null") ? (
                            <MemoizedTooltipIcon
                                title="Pitch Deck"
                                onClick={() => handleOpenPDFViewer({ row: item })}
                                icon={<Description sx={{ color: theme.palette.customColors.indigo600 }} />}
                            />
                        ) : (
                            <>-</>
                        ),
                        links: (
                            (
                                (item?.website_url && item?.website_url?.length > 0 || item?.linkedin_url && item?.linkedin_url?.length > 0 || item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id)
                                    ? <Box display="flex" alignItems={"center"} justifyContent={"center"} >
                                        {item?.website_url && item?.website_url?.length > 0 && <MemoizedTooltipIcon
                                            title="Website"
                                            onClick={() => window.open(item?.website_url)}
                                            icon={<LanguageOutlined sx={{ color: theme.palette.customColors.indigo600 }} />}
                                        />
                                        }
                                        {
                                            item?.linkedin_url && item?.linkedin_url?.length > 0 && <MemoizedTooltipIcon
                                                title="LinkedIn"
                                                onClick={() => window.open(item?.linkedin_url)}
                                                icon={<LinkedIn sx={{ color: theme.palette.customColors.indigo600 }} />}
                                            />
                                        }
                                        {
                                            item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id && <MemoizedTooltipIcon
                                                title="View Round Details"
                                                onClick={() => {
                                                    if (item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id) {
                                                        Cookies.set("startup_id", item?._id);
                                                        navigate(location ? `view-round` : `/deal-flow/view-round`)
                                                    }
                                                }}
                                                icon={<RoundDetailsIcon fill={theme.palette.customColors.indigo600} style={{ width: 20, height: 20 }} />}
                                            />
                                        }
                                    </Box> : '-')
                        )
                    })
                })
                : [];
        }, [transformedData]);
    };

    let location = window.location.pathname?.includes("deal-flow");

    const StartupLink = React.memo(({ row, children }) => {

        // console.log(row?.original?.startup_rounds_info,"row")
        return (
            <Stack onClick={() => {
                if (row?.original?._id) {
                    Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
                }
            }} style={{ textDecoration: 'none', color: '#616161', fontWeight: 700, cursor: 'pointer' }}>
                {/* <Link to={`view/${row?._id}`} > */}
                {children}
            </Stack>
        )
    })

    const {
        mutateAsync: saveInterestAsync,
        status: saveInterestStatus,
        error: saveInterestError,
        isLoading: isSavingInterest,
        data: saveInterestResponse,
    } = SaveInterest();

    const {
        mutateAsync: saveFeedbackAsync,
        status: saveFeedbackStatus,
        error: saveFeedbackError,
        isLoading: isSavingFeedback,
        data: saveFeedbackResponse,
    } = SaveFeedback();
    const {
        mutateAsync: saveManageNotesAsync,

    } = SaveManageNotes();

    const [currentRow, setCurrentRow] = React.useState(null);
    const [selectedPDF, setSelectedPDF] = React.useState('');

    // Cross inside the search field: clears the search term only, filters are
    // reset from the filter popup.
    const handleSearchReset = () => {
        setSearch('');
        Cookies.set("search_startups", '');
        setSearchStatus(false);
        setPage(1);
        setReset(!reset);
    }

    const handleFilterOpen = () => {
        setOpenFilter(true);
    }

    const handleFilterClose = () => {
        setOpenFilter(false)
    }

    const handleUpdateFilter = ({ query = {} }) => {
        // console.log(query,"query")
        setQueryParams(query);
        Cookies.set("startups_query", JSON.stringify(query));
        handleFilterClose();
    }

    const [openFeedbackPopup, setOpenFeedbackPopup] = React.useState(false)
    const [openShowInterestPopup, setOpenShowInterestPopup] = React.useState(false)
    // const [openManageNotes, setOpenManageNotes] = React.useState(false)


    const handleFeedbackPopupOpen = ({ row }) => {
        let request = {
            startup_id: row?.original?._id,
            investor_id: investor_id
        }

        // console.log(request, "row")
        FetchStatusAsync(request).then((response) => {
            // console.log(response,"resssss")
            // setIsEnabledInterest(response?.data?.investorInfo == null)
            setIsEnabledFeedback(response?.data?.feedback == null)
            if (response?.data?.feedback !== null) {
                setOpenFeedbackPopup(false);
                setAlertMessage(`You have already submitted feedback for ${row?.original?.startup_name}. Please wait to hear back from the startup.`)
                setAlertHeading("Feedback")
                setShowAlert(true);
            }
            else {
                setOpenFeedbackPopup(true);
                setAlertMessage(null)
                setAlertHeading(null)
                setShowAlert(false);
            }
        }).catch(err => {
            addToast(err?.response?.data?.message, "error")
            // toast.error(<CustomToast message={err?.response?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} />, {
            //     duration: 4000,
            //     position: "top-right",
            //     style: {
            //         padding: "15px 30px",
            //     },
            // });
        });


        setCurrentRow(row?.original);
    }

    const handleFeedbackPopupClose = () => {
        !Boolean(selectedPDF != null && selectedPDF?.length > 0) && setCurrentRow(null)
        setOpenFeedbackPopup(false)
    }

    const handleFeedbackSubmit = ({ row, values }) => {
        // console.log(row, "row")
        let request = {
            startup_id: row?._id,
            investor_id: investor_id,
            ratings: {
                problem: values?.problem,
                market: values?.market,
                product: values?.product,
                team: values?.team,
                traction: values?.traction
            },
            investible: values?.invest,
            feedback: values?.feedback
        }
        // console.log(request, "request")
        saveFeedbackAsync(request).then(() => {
            refetchListing()
        })
        // setQueryParams(query);
        handleFeedbackPopupClose();
    }


    const handleShowInterestPopupOpen = ({ row }) => {
        let request = {
            startup_id: row?.original?._id,
            investor_id: investor_id
        }

        // console.log(request, "row")
        // FetchStatusAsync(request).then((response) => {
        //     // console.log(response,"resssss")
        //     setIsEnabledInterest(response?.data?.investorInfo == null)
        //     // setIsEnabledFeedback(response?.data?.feedback == null)
        //     if (response?.data?.investorInfo !== null) {
        //         setOpenShowInterestPopup(false);
        //         setAlertMessage(`You have already shown investment interest in ${row?.original?.startup_name}. Please wait to hear back from the startup.`)
        //         setAlertHeading("Investment Interest")
        //         setShowAlert(true);
        //     }
        //     else {
        //         setOpenShowInterestPopup(true);
        //         setAlertMessage(null)
        //         setAlertHeading(null)
        //         setShowAlert(false);
        //     }
        // }).catch(err => {
        //     // toast.error(<CustomToast message={err?.response?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} />, {
        //     //     duration: 4000,
        //     //     position: "top-right",
        //     //     style: {
        //     //         padding: "15px 30px",
        //     //     },
        //     // });
        //     addToast(err?.response?.data?.message, "error")
        // });

        setOpenShowInterestPopup(true);
        setAlertMessage(null)
        setAlertHeading(null)
        setShowAlert(false);

        setCurrentRow(row?.original);
    }

    const handleShowInterestPopupClose = () => {
        !Boolean(selectedPDF != null && selectedPDF?.length > 0) && setCurrentRow(null);
        setOpenShowInterestPopup(false)
    }

    const handleShowInterestPopupSubmit = ({ row, values }) => {
        // console.log(row, "row")
        const payload = {
            status: "in-progress"
        }
        let request = {
            startup_id: row?._id,
            interested_amount: Number(String(values?.interested_amount)?.replaceAll(",", "")) || 0,
            investor_id: investor_id,
            currency_id: values?.currency_id,
            ...(row?.pipeline_status === "in-progress" ? { ...payload } : {})
        }
        // console.log(request, "request");
        saveInterestAsync(request).then(() => {
            refetchListing()
        })
        handleShowInterestPopupClose();
    }

    // const handleManageNotesOpen = ({ row }) => {
    //     setCurrentRow(row?.original);
    //     setOpenManageNotes(true);
    // }

    // const handleManageNotesClose = () => {
    //     setCurrentRow(null)
    //     setOpenManageNotes(false)
    // }

    // const handleManageNotesSubmit = ({ row, values }) => {
    //     let request = {
    //         startup_id: row?.startup_id,
    //         investor_id: investor_id,
    //         message: values?.message
    //     }
    //     saveManageNotesAsync(request).then(() => {
    //         refetchListing()
    //     })
    //     handleManageNotesClose();
    // }

    const {
        mutateAsync: updateStartupStatusAsync,
        status: updateStartupStatusStatus,
        error: updateStartupStatusError,
        isLoading: isUpdatingStartupStatus,
        data: updateStartupStatusResponse,
    } = ChangePipelineInvestorStatus();

    const {
        mutateAsync: inviteStartupAsync,
        status: inviteStartupStatus,
        error: inviteStartupError,
        isLoading: isInvitingStartup,
        data: inviteStartupResponse,
    } = InviteStartupPOST({ investor_id: investor_id });

    const [openShortlistConfirmationPopup, setOpenShortlistConfirmationPopup] = React.useState(false);

    const handleShortlistConfirmationPopupClose = () => {
        setOpenShortlistConfirmationPopup(false);
        setCurrentRow(null);
    }

    const handleShortlistConfirmationPopupOpen = ({ row }) => {
        setOpenShortlistConfirmationPopup(true);
        setCurrentRow(row?.original);
    }

    const handleSubmissionShortlist = ({ row }) => {
        updateStartupStatusAsync({
            payload: {
                "status": "interested",
                // "interested_shown_date": new Date().toISOString()
            }
            , pipeline_id: currentRow?.pipeline_id
        }).then((response) => {
            addToast("Moved to Shortlisted", "success")
            refetchListing();
            handleShortlistConfirmationPopupClose();
        }).catch((error) => {

        })

    }

    const [openInProgressConfirmationPopup, setOpenInProgressConfirmationPopup] = React.useState(false);

    const handleInProgressConfirmationPopupClose = () => {
        setOpenInProgressConfirmationPopup(false);
        setCurrentRow(null);
    }

    const handleInProgressConfirmationPopupOpen = ({ row }) => {
        setOpenInProgressConfirmationPopup(true);
        setCurrentRow(row?.original);
    }

    const handleSubmissionInProgress = ({ row }) => {
        updateStartupStatusAsync({
            payload: {
                "status": "in-progress",
                // "interested_shown_date": new Date().toISOString()
            }
            , pipeline_id: currentRow?.pipeline_id
        }).then((response) => {
            addToast("Moved to Selected", "success")
            refetchListing();
            handleInProgressConfirmationPopupClose();
        }).catch((error) => {

        })

    }

    const [openRejectConfirmationPopup, setOpenRejectConfirmationPopup] = React.useState(false);

    const handleRejectConfirmationPopupClose = () => {
        setOpenRejectConfirmationPopup(false);
        setCurrentRow(null);
    }

    const handleRejectConfirmationPopupOpen = ({ row }) => {
        setOpenRejectConfirmationPopup(true);
        setCurrentRow(row?.original);
    }

    const handleSubmissionReject = ({ row }) => {
        // setCurrentRow(row);
        // console.log(row);
        // updateStartupStatusAsync({
        //     "startup_id": "66f285de9ce0f2c5615f20e5",
        //     "status_code": "rejected"
        // }).then((response) => {
        //     refetchListing();
        //     handleRejectConfirmationPopupClose();
        // }).catch((error) => {

        // })

        updateStartupStatusAsync({
            payload: {
                "status": "rejected"
            }
            , pipeline_id: currentRow?.pipeline_id
        }).then((response) => {
            addToast("Moved to Rejected", "success")
            refetchListing();
            handleRejectConfirmationPopupClose();
        }).catch((error) => {

        })
    }

    const [openRequestDocumentsPopup, setOpenRequestDocumentsPopup] = React.useState(false);

    const handleRequestDocumentsPopupClose = () => {
        setOpenRequestDocumentsPopup(false);
        setCurrentRow(null);
    }

    const handleRequestDocumentsPopupOpen = ({ row }) => {
        setOpenRequestDocumentsPopup(true);
        setCurrentRow(row?.original);
    }

    const handleRequestDocuments = ({ row }) => {
        // setCurrentRow(row);
        // console.log(row);
        handleShortlistConfirmationPopupClose();
    }

    const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const [openInviteStartupPopup, setOpenInviteStartupPopup] = React.useState(false);

    const handleInviteStartupPopupClose = () => {
        setOpenInviteStartupPopup(false);
    }

    const handleInviteStartupPopupOpen = () => {
        setOpenInviteStartupPopup(true);
    }

    const handleInviteStartup = async ({ payload }) => {
        // console.log(payload, "Please enter startup name");
        await inviteStartupAsync({
            payload, _id: investor_id
        }).then((response) => {
            refetchListing();
            handleInviteStartupPopupClose();
        }).catch((error) => {
            console.log(error?.message)
        })
    }

    const Actions = ({ hasNoData = false }) => {
        return hasPermission("startups", "invite", userPermissions) && <>
            <B400
                // disabled={!hasPermission("startups", "invite", userPermissions)}
                sx={{
                    display: 'flex',
                    marginLeft: hasNoData ? "none" : 'auto',
                    background: theme.palette.customColors.indigo700,
                    padding: "0.625rem 1rem",
                    "& > .MuiButton-icon.MuiButton-startIcon":
                    {
                        marginRight: isMediumScreen ? 0 : '0.5rem',
                        marginLeft: isMediumScreen ? 0 : '-0.25rem'
                    }
                }} startIcon={<Add sx={{ width: 20, height: 20 }} />}
                onClick={() => {
                    hasPermission("startups", "invite", userPermissions) && handleInviteStartupPopupOpen()
                }}>{isMediumScreen ? "" : "Invite"}</B400>
        </>
    }

    React.useEffect(() => {
        refetchListing();
    }, [reset]);

    const isShortlisting = false;
    const isRejecting = false;
    const isRequestingDocuments = false;
    const stagesListing = startup_stages && startup_stages?.length > 0 ? startup_stages?.map(item => ({ label: item?.name, value: item?._id })) : []
    const categoriesListing = startup_categories && startup_categories?.length > 0 ? startup_categories?.map(item => ({ label: item?.name, value: item?._id })) : []
    const subCategoriesListing = startup_sub_categories && startup_sub_categories?.length > 0 ? startup_sub_categories?.map(item => ({ label: item?.sub_category, value: item?._id })) : []
    // console.log(queryParams, subCategoriesListing, "queryParams")

    const FormattedData = useFormattedData(transformedData);



    const handleOpenPDFViewer = ({ row }) => {
        setCurrentRow(row);
        // console.log(currentRow,"currentRow")
        setSelectedPDF(row?.pitchDeckFileUrl);
    }

    const handleClosePDFViewer = () => {
        setSelectedPDF(null);
        setCurrentRow(null);
    }

    const updateSector = (params) => {
        let removedSectorParamFromQuery = params;
        removedSectorParamFromQuery.sector && delete removedSectorParamFromQuery.sector;
        // Cookies.set("startups_query", JSON.stringify({ ...removedSectorParamFromQuery }));
        setQueryParams({ ...removedSectorParamFromQuery });
        setSector(null);
        setSearchStatus(false)
    }

    // console.log(transformedData, "transformedData", FormattedData)

    return (
        <>
            <AlertDialog open={showAlert} handleClose={() => { setShowAlert(false); setTimeout(() => { setAlertMessage(null); setAlertHeading(null) }, 1000) }} heading={alertHeading} subheading={alertMessage} />
            <PDFView open={Boolean(selectedPDF != null && selectedPDF?.length > 0)} pdfUrl={selectedPDF} handleClose={handleClosePDFViewer} handleFeedbackPopupOpen={handleFeedbackPopupOpen} handleShowInterestPopupOpen={handleShowInterestPopupOpen} currentRow={currentRow} isEnabledFeedback={isEnabledFeedback} isEnabledInterest={isEnabledInterest} />
            <InviteStartupPopup open={openInviteStartupPopup} handleClose={handleInviteStartupPopupClose} isSharingDocuments={false} refetchListing={refetchListing} handleSubmission={handleInviteStartup} isInvitingStartup={isInvitingStartup} />
            <ModalComponent open={openFilter} onClose={handleFilterClose} style={{ maxWidth: 640, width: "100%" }}>
                <FilterPopup queryParams={queryParams} setQueryParams={setQueryParams} handleClose={handleFilterClose} handleSubmit={handleUpdateFilter} stage={stage} category={category} sector={sector} setStage={setStage} setCategory={setCategory} setSector={setSector} />
            </ModalComponent>
            <InvitedConfirmationPopup open={openInvitedConfirmationPopup} handleClose={handleInvitedConfirmationPopupClose} handleSubmission={handleSubmissionInvited} heading={"Move to New"} ActionText={"Submit"} subheading={"Are you sure you want to move to new startups?"} isLoading={isUpdatingStartupStatus} currentRow={currentRow} optional={true} />
            <ShortlistConfirmationPopup open={openShortlistConfirmationPopup} handleClose={handleShortlistConfirmationPopupClose} handleSubmission={handleSubmissionShortlist} heading={"Move to Shortlist"} ActionText={"Submit"} subheading={"Are you sure you want to move to shortlisted startups?"} isLoading={isUpdatingStartupStatus} currentRow={currentRow} optional={true} />
            <InProgressConfirmationPopup open={openInProgressConfirmationPopup} handleClose={handleInProgressConfirmationPopupClose} handleSubmission={handleSubmissionInProgress} heading={"Move to Selected"} ActionText={"Submit"} subheading={"Are you sure you want to move to selected startups?"} isLoading={isUpdatingStartupStatus} currentRow={currentRow} optional={true} />
            <RejectedConfirmationPopup open={openRejectConfirmationPopup} handleClose={handleRejectConfirmationPopupClose} handleSubmission={handleSubmissionReject} heading={"Move to Rejected"} ActionText={"Reject"} subheading={"Are you sure you want to move to rejected startups?"} isLoading={isUpdatingStartupStatus} currentRow={currentRow} optional={false} />
            <RequestDocumentsPopup open={openRequestDocumentsPopup} handleClose={handleRequestDocumentsPopupClose} handleSubmission={handleRequestDocuments} heading={"Request Documents"} ActionText={"Request"} subheading={"Are you sure you want to request documents for selected startup?"} isLoading={isRequestingDocuments} currentRow={currentRow} />
            <ModalComponent open={openFeedbackPopup} onClose={handleFeedbackPopupClose} style={{ maxWidth: 640, width: "100%" }}>
                <FeedbackPopup currentRow={currentRow} handleClose={handleFeedbackPopupClose} handleSubmit={handleFeedbackSubmit} />
            </ModalComponent>
            <ModalComponent open={openShowInterestPopup} onClose={handleShowInterestPopupClose} style={{ maxWidth: 640, width: "100%" }}>
                <ShowInterestPopup currentRow={currentRow} handleClose={handleShowInterestPopupClose} handleSubmit={handleShowInterestPopupSubmit} />
            </ModalComponent>
            {/* <ModalComponent open={openManageNotes} onClose={handleManageNotesClose} style={{ maxWidth: 800, width: "100%" }}>
                <ManageNotes currentRow={currentRow} handleClose={handleManageNotesClose} handleSubmit={handleManageNotesSubmit} />
            </ModalComponent> */}
            <ThemeBGWrapper bgColor={theme.palette.customColors.yellow_bg}>
                <BreadcrumbHeader title={"Deal Flow"} sx={{ paddingBottom: 0 }} Actions={() => <NeedHelpButton />} />
                <Grid container xs={12} padding={{ xs: "0 0rem 1rem 0rem", md: "0 0rem 2rem 0rem" }} justifyContent={"space-between"}>
                    <TabContext value={value}>
                        <Grid container xs={12} pt={1} pb={0} spacing={0} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
                            {/* <Grid item xs={10} lg={10}> */}
                            <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{ gap: "0.5rem" }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} mb={1}>
                                <Grid item xs={12} md={4} display={"flex"} flexWrap={"nowrap"} container gap={1}>
                                    <CustomInputField
                                        autoComplete="off"
                                        sx={{
                                            marginBottom: 0,
                                            "& > .MuiFilledInput-root": {
                                                borderColor: `${theme.palette.customColors.b50} !important`,
                                                borderRadius: '8px'
                                            }
                                        }}
                                        fullWidth
                                        value={search}
                                        name={`search_${Math.random().toString(36).substring(7)}`}  // Set a random name attribute
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                // alert(e.target.value);
                                                refetchListing()
                                                if (search) {
                                                    setSearchStatus(true)
                                                }
                                                setPage(1);
                                            }
                                        }}
                                        onChange={(event) => {
                                            setSearch(event.target.value)
                                            Cookies.set("search_startups", event.target.value);
                                            setSearchStatus(false)
                                        }}
                                        size="small"
                                        startAdornment={<>
                                            <Search sx={{ padding: "0rem 0rem 0rem 0.5rem" }} />
                                        </>}
                                        onClear={handleSearchReset}
                                        placeholder={'Search by name'}
                                    />
                                    <Tooltip title="Filter">
                                        <IconButton sx={{ marginLeft: "auto", display: { xs: 'flex', md: "flex" }, marginBlock: 'auto' }} onClick={() => handleFilterOpen()}>
                                            {Object.keys(queryParams)?.length > 0 ? <FilterAltRounded sx={{ color: theme?.palette?.customColors.indigo700 }} /> : <FilterAltOutlined />}
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} >
                                <Grid xs={12} container sx={{ bgcolor: 'white', borderRadius: '8px 8px 0 0', borderInline: `1px solid ${theme.palette.customColors.b50}`, borderBlockStart: `1px solid ${theme.palette.customColors.b50}` }}>
                                    <Grid width="75%">
                                        <CustomTabs
                                            variant="submenu"
                                            titleStyle={{ fontSize: '1rem' }}
                                            tabStyle={{ padding: { xs: '0.5rem 1rem 0rem' } }}
                                            sx={{ border: '0px solid black !important' }}
                                            bgColor={"transparent"}
                                            allowScrollButtonsMobile={true}
                                            data={
                                                [...startupTabs?.map(item => {
                                                    return ({ ...item, label: `${item?.label} ${value === item?.value && isLoadingStartupListing === false && startupListingStatus == "success" && transformedData?.count && transformedData?.count != 0 ? `(${transformedData?.count})` : ""}` })
                                                })]
                                            } value={value} handleChange={handleTabChange}
                                            isSmallScreen={isSmallScreen} className={classes.scrollTabs} key={"Tabs Tabs"} indicatorFullSize={false} />
                                    </Grid>
                                    <Grid width="20%" pt={0.75} pr={1} marginLeft={"auto"}>
                                        <Actions />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* { */}
                            {/* <Grid item xs={12} md={12} pt={"0 !important"} marginInline={"auto"} maxWidth={"100%"}> */}

                            {isLoadingStartupListing && !transformedData ?
                                <Grid item xs={12} height={"100dvh"} sx={{ width: '100%', padding: "2rem", paddingLeft: "2rem !important", paddingTop: "0rem !important", bgColor: theme.palette.customColors.yellow_bg }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                                    <Box className='skeleton' minHeight={"60dvh"} sx={{ borderRadius: "0 0 8px 8px", border: `1px solid ${theme.palette.customColors.b50}` }} marginTop={0}>

                                    </Box>
                                </Grid> :
                                <Box className='startups-listing' width={"100%"} maxHeight="100%" paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                                    <AsyncTableListing
                                        columns={columns}
                                        // data={[]}
                                        tabValue={value}
                                        data={FormattedData}
                                        // title={"Investors"}
                                        // chipText={`${data?.length}${isSmallScreen ? "" : " Investors"}`}
                                        // actions={Actions}
                                        noDataPlaceHolderImage={value == "invited" ? placeHolderImageNew : value == "interested" ? placeHolderImageShortlisted : value == "in-progress" ? placeHolderImageShortlisted : placeHolderImageRejected}
                                        noDataTitle={"No Startups"}
                                        noDataSubTitle={value == "invited" ? "You do not have any new startups. Start adding now" : value == "interested" ? "You do not have any shortlisted startups." : value == "in-progress" ? "You do not have any selected startups." : "You do not have any rejected startups."}
                                        noDataPlaceHolderSx={value == "interested" ? { width: 300 } : {}}
                                        actions={value === "invited" ? () => <Actions hasNoData={true} /> : () => { }}
                                        CustomLink={StartupLink}
                                        page={page}
                                        setPage={setPage}
                                        limit={limit}
                                        setLimit={setLimit}
                                        count={transformedData?.count}
                                        RowActions={RowActions}
                                        sx={{ borderRadius: '0 0 8px 8px', border: `1px solid ${theme.palette.customColors.b50}` }}
                                        refetchListing={refetchListing}
                                        maxHeight={transformedData?.count > 10 ? "calc(100dvh - 13rem)" : "calc(100dvh - 14rem)"}
                                    />
                                </Box>
                            }

                            {/* </Grid>} */}
                            {/* <Grid item xs={2} lg={2}> */}

                        </Grid>
                    </TabContext>
                </Grid>
            </ThemeBGWrapper>
        </>
    )
}

export default StartupsListing